import DataCard from '../../../lib/DataCard/DataCard';
import {dateFormatter, formatCurrency} from '../../../utils/util';
import {
  amountFormatKeys,
  dateFormatKeys,
  scheduleLoanFieldsMapping,
} from '../../scheduleInstallments/paymentScheduleConstant';

import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

import './PaymentScheduleMobile.css';

const PaymentScheduleMobile = (props) => {
  const [rowData, setRowData] = React.useState(null);
  const {t} = useTranslation();

  const transformArray = () => {
    let temp = {};
    if (props.allfields) {
      for (const field of props.allfields) {
        let component =
          props.schedulePayments[scheduleLoanFieldsMapping[field]] === undefined
            ? '---'
            : props.schedulePayments[scheduleLoanFieldsMapping[field]];

        if (component !== '---') {
          if (dateFormatKeys.includes(field)) {
            component = dateFormatter(component);
          } else if (amountFormatKeys.includes(field)) {
            component = formatCurrency(component);
          }
        }

        temp[field] = {
          value: props.schedulePayments[scheduleLoanFieldsMapping[field]],
          component: component,
          ...(field === 'AMOUNT' && props.country === 'pt'
            ? {infoIconText: t('AMOUNT_TOOLTIP')}
            : {}),
        };
      }
    }
    setRowData(temp);
  };

  const headCells = ['CONTRACT_NUMBER'];
  let bodyCells = props.allfields.filter(
    (field) => field !== 'CONTRACT_NUMBER'
  );
  const badgeColorMap = {
    'LOAN-INSTALLMENT': 'loanBadge',
    'LOAN-HIRE-PURCHASE': 'hpBadge',
    'LEASE-OPERATING': 'leaseBadge',
    'LEASE-FINANCE': 'leaseBadge',
    'LEASE-FINANCE-MUN': 'leaseBadge',
    'LEASE-FINANCE-NON-MUN': 'leaseBadge',
  };

  React.useEffect(() => {
    transformArray();
  }, [props.schedulePayments]);

  return (
    rowData && (
      <DataCard
        key={props.key}
        data={rowData}
        cardHead={headCells}
        cardBody={bodyCells}
        badge={props.ProductType}
        badgeClass={badgeColorMap[props.ProductType]}
        className={'PaymentScheduleCard'}
      />
    )
  );
};
PaymentScheduleMobile.propTypes = {
  allfields: PropTypes.array,
  schedulePayments: PropTypes.object,
  ProductType: PropTypes.string,
  country: PropTypes.string,
};

export default PaymentScheduleMobile;
